import { __extends } from "tslib";
import config from '../config';
import Flow from './Flow';
var ContactDetails = /*@__PURE__*/ (function (_super) {
    __extends(ContactDetails, _super);
    function ContactDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.init = function () {
            _this.setRoamingStepperItem(config.appointman.flow.CONTACT_DETAILS);
            _this.apmType = _this.getState().apmType;
            _this.apmTopic = '';
            if (_this.getState().CURRENT_FLOW === config.appointman.flow.CONTACT_DETAILS) {
                _this.activate();
            }
            _this.registerFormElements();
            _this.registerEventListeners();
            _this.errors = 0;
            _this.flow = _this.getState().CURRENT_FLOW;
            if (_this.getState().apmID) {
                _this.getItem().setComplete(true);
                _this.getItem().setLabel(_this.buildPreviewLabel());
            }
        };
        _this.registerFormElements = function () {
            _this.firstnameElement = jQuery(_this.getElement()).find('[name=firstname]').get(0);
            _this.lastnameElement = jQuery(_this.getElement()).find('[name=lastname]').get(0);
            _this.emailElement = jQuery(_this.getElement()).find('[name=email]').get(0);
            _this.phoneElement = jQuery(_this.getElement()).find('[name=phone]').get(0);
            _this.topicElement = jQuery(_this.getElement()).find('[name=topic]').get(0);
            _this.textElement = jQuery(_this.getElement()).find('[name=text]').get(0);
            if (_this.getState().firstname) {
                jQuery(_this.firstnameElement).val(_this.getState().firstname);
            }
            if (_this.getState().lastname) {
                jQuery(_this.lastnameElement).val(_this.getState().lastname);
            }
            if (_this.getState().email) {
                jQuery(_this.emailElement).val(_this.getState().email);
            }
            if (_this.getState().phone) {
                jQuery(_this.phoneElement).val(_this.getState().phone);
            }
            if (_this.getState().text) {
                jQuery(_this.textElement).val(_this.getState().text);
            }
        };
        _this.registerEventListeners = function () {
            jQuery(_this.firstnameElement).on('blur', _this.handleFirstnameValidation);
            jQuery(_this.lastnameElement).on('blur', _this.handleLastnameValidation);
            jQuery(_this.emailElement).on('blur', _this.handleEmailValidation);
            jQuery(_this.phoneElement).on('blur', _this.handlePhoneValidation);
            jQuery(_this.topicElement).on('change', _this.handleTopicValidation);
            jQuery(_this.textElement).on('blur', _this.handleTextValidation);
            _this.getItem().onChangeRequest(function () {
                _this.setState({
                    CURRENT_FLOW: config.appointman.flow.CONTACT_DETAILS
                });
                _this.getItem().setComplete(false);
                _this.getItem().setLabel(_this.buildActiveLabel());
            });
        };
        _this.handleFirstnameValidation = function () {
            var value = jQuery(_this.firstnameElement).val().trim();
            var errorMsg = false;
            if (value.length < 1) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.FIRSTNAME_MISSING;
            }
            else if (value.length < 2) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.FIRSTNAME_INVALID;
            }
            else if (value.length > 400) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.FIRSTNAME_TOOLONG;
            }
            if (errorMsg) {
                jQuery(_this.firstnameElement).addClass('fm-error-border');
                jQuery(_this.firstnameElement).parent().parent().find('.fm-formerror').html(errorMsg);
                _this.errors++;
                _this.setState({
                    firstname: false
                });
                return false;
            }
            _this.setState({
                firstname: value
            });
            jQuery(_this.firstnameElement).removeClass('fm-error-border');
            jQuery(_this.firstnameElement).parent().parent().find('.fm-formerror').html('');
            return true;
        };
        _this.handleLastnameValidation = function () {
            var value = jQuery(_this.lastnameElement).val().trim();
            var errorMsg = false;
            if (value.length < 1) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.LASTNAME_MISSING;
            }
            else if (value.length < 2) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.LASTNAME_INVALID;
            }
            else if (value.length > 400) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.LASTNAME_TOOLONG;
            }
            if (errorMsg) {
                jQuery(_this.lastnameElement).addClass('fm-error-border');
                jQuery(_this.lastnameElement).parent().parent().find('.fm-formerror').html(errorMsg);
                _this.errors++;
                _this.setState({
                    lastname: false
                });
                return false;
            }
            _this.setState({
                lastname: value
            });
            jQuery(_this.lastnameElement).removeClass('fm-error-border');
            jQuery(_this.lastnameElement).parent().parent().find('.fm-formerror').html('');
            return true;
        };
        _this.handleEmailValidation = function () {
            var value = jQuery(_this.emailElement).val().trim();
            var errorMsg = false;
            if (value.length < 1) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.EMAIL_MISSING;
            }
            else if (!_this.validateEmail(value)) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.EMAIL_INVALID;
            }
            else if (value.length > 400) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.EMAIL_TOOLONG;
            }
            if (errorMsg) {
                jQuery(_this.emailElement).addClass('fm-error-border');
                jQuery(_this.emailElement).parent().parent().find('.fm-formerror').html(errorMsg);
                _this.errors++;
                _this.setState({
                    email: false
                });
                return false;
            }
            jQuery(_this.emailElement).removeClass('fm-error-border');
            jQuery(_this.emailElement).parent().parent().find('.fm-formerror').html('');
            _this.setState({
                email: value
            });
            return true;
        };
        _this.handlePhoneValidation = function () {
            var value = jQuery(_this.phoneElement).val().trim();
            var errorMsg = false;
            var regex = /^[0-9 ()-]+$/;
            if (value.length < 1) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.PHONE_MISSING;
            }
            else if (value.length > 400) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.PHONE_TOOLONG;
            }
            else if (!regex.test(value)) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.PHONE_INVALID;
            }
            if (errorMsg) {
                jQuery(_this.phoneElement).addClass('fm-error-border');
                jQuery(_this.phoneElement).parent().parent().find('.fm-formerror').html(errorMsg);
                _this.errors++;
                _this.setState({
                    phone: false
                });
                return false;
            }
            jQuery(_this.phoneElement).removeClass('fm-error-border');
            jQuery(_this.phoneElement).parent().parent().find('.fm-formerror').html('');
            _this.setState({
                phone: value
            });
            return true;
        };
        _this.handleTopicValidation = function () {
            var value = jQuery(_this.topicElement).val().trim();
            var errorMsg = false;
            if (value.length < 1) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.TOPIC_MISSING;
            }
            if (errorMsg) {
                jQuery(_this.topicElement).addClass('fm-error-border');
                jQuery(_this.topicElement).parent().parent().find('.fm-formerror').html(errorMsg);
                _this.errors++;
                _this.setState({
                    apmTopic: false
                });
                return false;
            }
            jQuery(_this.topicElement).removeClass('fm-error-border');
            jQuery(_this.topicElement).parent().parent().find('.fm-formerror').html('');
            _this.setState({
                apmTopic: value
            });
            return true;
        };
        _this.handleTextValidation = function () {
            var value = jQuery(_this.textElement).val().trim();
            var errorMsg = false;
            if (value.length > 6000) {
                errorMsg = config.appointman.msg.CONTACT_DETAILS_VALIDATION.TEXT_TOOLONG;
            }
            if (errorMsg) {
                jQuery(_this.textElement).addClass('fm-error-border');
                jQuery(_this.textElement).parent().find('.fm-formerror').html(errorMsg);
                _this.errors++;
                _this.setState({
                    text: false
                });
                return false;
            }
            _this.setState({
                text: value
            });
            jQuery(_this.textElement).removeClass('fm-error-border');
            jQuery(_this.textElement).parent().parent().find('.fm-formerror').html('');
            return true;
        };
        return _this;
    }
    ContactDetails.prototype.onStateChange = function () {
        var state = this.getState();
        if (state.CURRENT_FLOW === config.appointman.flow.CONTACT_DETAILS) {
            if (this.flow !== state.CURRENT_FLOW) {
                this.flow = state.CURRENT_FLOW;
                this.activate();
            }
        }
        else {
            this.flow = state.CURRENT_FLOW;
        }
        if (state.apmType !== this.apmType || state.apmTopic !== this.apmTopic) {
            this.apmType = state.apmType;
            this.apmTopic = state.apmTopic;
            this.renderTopicOptions();
        }
        if (this.validateState(state)) {
            this.enableNextButton();
        }
        else {
            this.disableNextButton();
        }
    };
    ContactDetails.prototype.renderTopicOptions = function () {
        var type = this.getState().apmType;
        var topics = this.getState().availableApmTypeTopics[type];
        var topicElement = jQuery('<select name="topic"></select>');
        var labelItem = jQuery(ContactDetails.TOPIC_LABEL_HTML.replace('%label', config.appointman.msg.CONTACT_DETAILS_SELECT_LABEL));
        topicElement
            .append(labelItem);
        for (var topic in topics) {
            var html = ContactDetails.TOPIC_OPTION_HTML
                .replace('%id', topic)
                .replace('%label', topics[topic]);
            if (this.getState().apmTopic === topic) {
                html = ContactDetails.SELECTED_TOPIC_OPTION_HTML
                    .replace('%id', topic)
                    .replace('%label', topics[topic]);
            }
            var item = jQuery(html);
            topicElement
                .append(item);
        }
        jQuery(this.getElement())
            .find('[name=topic]')
            .replaceWith(topicElement);
        this.topicElement = topicElement.get(0);
        window.vf['select-input'].init();
        topicElement.off('change').on('change', this.handleTopicValidation);
    };
    ContactDetails.prototype.validateState = function (state) {
        return state.firstname
            && state.lastname
            && state.email
            && state.phone
            && state.apmTopic;
    };
    ContactDetails.prototype.onNextRequest = function () {
        this.setState({
            CURRENT_FLOW: config.appointman.flow.SUMMARY
        });
        this.getItem().setComplete(true);
        this.getItem().setLabel(this.buildPreviewLabel());
    };
    ContactDetails.prototype.validateEmail = function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };
    ContactDetails.prototype.buildPreviewLabel = function () {
        var html = ContactDetails.PREVIEW_LABEL_HTML;
        var value = this.getState().firstname + " " + this.getState().lastname;
        html = html.replace('%s', value);
        return html;
    };
    ContactDetails.prototype.buildActiveLabel = function () {
        var html = ContactDetails.ACTIVE_LABEL_HTML;
        return html;
    };
    ContactDetails.TOPIC_OPTION_HTML = "<option value=\"%id\">%label</option>";
    ContactDetails.SELECTED_TOPIC_OPTION_HTML = "<option value=\"%id\" selected=\"selected\">%label</option>";
    ContactDetails.TOPIC_LABEL_HTML = "<option value=\"\">%label</option>";
    ContactDetails.PREVIEW_LABEL_HTML = config.appointman.msg.CONTACT_DETAILS_PREVIEW;
    ContactDetails.ACTIVE_LABEL_HTML = config.appointman.msg.CONTACT_DETAILS_ACTIVE;
    return ContactDetails;
}(Flow));
export default ContactDetails;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/flow/ContactDetails.ts
// module id = null
// module chunks = 